import {request,} from '@/common/requestZt.js'
import {ztUrl} from '@/common/const.js'

// 产品分类
export function CategoryList(query) {
    return request.get(ztUrl + '/product/category/list', query, localStorage.getItem('middle-token'))
}
